import styled from "styled-components";

export const FeedStyled = styled.div`
	display: flex;
	justify-content: center;

	.feed {
		color: var(--color-white-fixed);

		#sentinela {
			height: 5rem;
			width: 100%;
		}
	}

	#add-post {
		position: fixed;

		bottom: 25px;
		right: 25px;
	}

	.model-image {
		padding: 1rem 2rem;

		form {
			display: flex;
			flex-direction: column;
			row-gap: 2rem;
		}

		.model-image-container {
			width: 100%;
			border-radius: var(--radius);

			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;

			.add-img {
				color: var(--color-white-fixed);
				background-color: var(--color-brand-3);
				font-weight: 600;
				padding: 1rem 2rem;
				border-radius: 5px;
				box-shadow: 1px 2px 5px var(--color-gray-1);
				transition: all 0.3s ease;

				&:hover {
					filter: brightness(1.3);
					box-shadow: 1px 2px 5px var(--color-gray-0);
				}
			}

			.uploaded-images {
				img {
					width: 400px;
					height: 400px;

					@media screen and (max-width: 460px) {
						width: 300px;
						height: 300px;
					}
				}
			}

			img.default-image {
				width: 75px;
				opacity: 0.2;
			}
		}

		.model-footer {
			display: flex;
			justify-content: space-between;
			align-items: center;
			column-gap: 1rem;

			.user-img {
				background-color: var(--color-white-fixed);
			}

			.message {
				flex: 1;
				input {
					width: 100%;
					padding: 1.3rem 0rem 1.3rem 1.5rem;

					color: var(--color-white-fixed);
					background-color: var(--color-brand-5-transparent);
					border: none;
					border-radius: 20px;

					outline: none;

					transition: all 0.3s ease;

					&:hover {
						background-color: var(--color-brand-2);
					}

					&:focus {
						background-color: var(--color-brand-5);
					}
				}
			}
		}
	}
`;
